
export function serviceUnavailable (code) {
    switch (code) {
        case 500:
        case 501:
        case 502:
        case 503:
            return true;
        default:
            return false;
    }
}
